/**
 * Detects non-actionable Safari TypeError noise where minified code accesses
 * `.id` on a null/undefined object, producing an error with no usable stack
 * frames.
 *
 * Safari's "null is not an object (evaluating 'X.id')" pattern surfaces for
 * browser-internal, extension, SDK, or framework runtime errors that are not
 * tied to application code. The minified receiver name changes across
 * bundles (`o.id`, `s.id`, `n.id`), so we match any short identifier.
 *
 * We only suppress these when the stack trace contains no meaningful frames
 * — i.e. no reference to our source files or bundles.
 */
const SAFARI_MINIFIED_ID_ACCESS =
  /^(null|undefined) is not an object \(evaluating '[A-Za-z_$][\w$]{0,2}\.id'\)$/;

export const isSafariNullPropertyAccessNoise = (
  message: string | undefined,
  stack: string | undefined,
): boolean => {
  if (!message) {
    return false;
  }

  if (!SAFARI_MINIFIED_ID_ACCESS.test(message)) {
    return false;
  }

  if (!stack || stack === `TypeError: ${message}`) {
    return true;
  }

  const frames = stack.split("\n").filter((l) => l.trim().startsWith("at "));
  return frames.length === 0;
};
